import { render, staticRenderFns } from "./UiBracketsRounds.vue?vue&type=template&id=d1eb69ba&"
import script from "./UiBracketsRounds.vue?vue&type=script&lang=js&"
export * from "./UiBracketsRounds.vue?vue&type=script&lang=js&"
import style0 from "./UiBracketsRounds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports